'use client';
/** @jsxImportSource @emotion/react */

import type { SkeletonProps } from '@mui/material/Skeleton';

import MuiSkeleton from '@mui/material/Skeleton';

export type { SkeletonProps };
export const Skeleton = MuiSkeleton;
